import { useStatistics } from './StatiscticsContext';
import ArrowRedUpIcon from '@/assets/icons/V3/arrow/ArrowRedUpIcon.svg?react';
import ArrowBlueDownIcon from '@/assets/icons/V3/arrow/ArrowBlueDownIcon.svg?react';

import { autoComma } from '@/utils/parser';
import { BarChart } from '@/components/V3/Chart/BarChart';
import { useMembershipPreviewMode } from '@/components/membership/MembershipContentLock';
import { membershipStatisticsMock } from './membership-statistics-mock';

interface Props {
  isDashboard?: boolean;
}

const BarChartSection = ({ isDashboard }: Props) => {
  const isPreviewMode = useMembershipPreviewMode();
  const {
    activedMonthlySales,
    isRegisteredMarket,
    totalSalesAmount,
    monthlySalesList,
    setActivedMonthlySales,
  } = useStatistics();

  const showOverlay = (!isRegisteredMarket || totalSalesAmount === 0) && !isDashboard;

  // 데이터 분기: showOverlay면 목데이터, 아니면 실제 데이터
  const chartMonthlySalesList = showOverlay
    ? MOCK_CHART_MONTHLY_SALES_LIST
    : monthlySalesList.slice(-(monthlySalesList.length - 1));

  const activeSales = showOverlay
    ? MOCK_CHART_MONTHLY_SALES_LIST[MOCK_CHART_MONTHLY_SALES_LIST.length - 1]
    : activedMonthlySales;

  const currentIdx = showOverlay
    ? MOCK_CHART_MONTHLY_SALES_LIST.length - 1
    : monthlySalesList.findIndex((item) => item.Month === activedMonthlySales.Month);

  const prevMonth = showOverlay
    ? MOCK_CHART_MONTHLY_SALES_LIST[currentIdx - 1]
    : monthlySalesList[currentIdx - 1];

  const diff = activeSales.SalesAmount - (prevMonth?.SalesAmount ?? 0);
  const displayDiff = isPreviewMode || showOverlay ? MOCK_DIFF : diff;

  return (
    <div className="flex  flex-col gap-4 rounded-[16px] bg-white p-[16px]">
      <div className="flex flex-col gap-2">
        <div className="text-gr-900 Body1S16">매출 추이</div>
        <div className="flex flex-wrap gap-2">
          <div className="text-gr-800 Title3S18">
            {/* {autoComma(activedMonthlySales.SalesAmount)}원 */}
            {autoComma(activeSales.SalesAmount)}원
          </div>
          {activeSales.SalesAmount > 0 && (
            <div
              className={`flex items-center gap-[2px] Caption1M12 ${
                displayDiff >= 0 ? 'text-red-400' : 'text-blue-400'
              }`}
            >
              <span>지난달 같은 기간 보다</span>
              <div className="flex items-center">
                {displayDiff >= 0 ? <ArrowRedUpIcon /> : <ArrowBlueDownIcon />}
                <span>{autoComma(Math.abs(displayDiff))}</span>
              </div>
            </div>
          )}
        </div>
      </div>
      {activeSales.SalesAmount > 0 && (
        <div data-membership-preview-interactive={isPreviewMode ? 'true' : undefined}>
          <BarChart
            PcVersion
            monthlySalesList={chartMonthlySalesList}
            onClickBar={setActivedMonthlySales}
            activedMonthlySales={
              showOverlay
                ? MOCK_CHART_MONTHLY_SALES_LIST[MOCK_CHART_MONTHLY_SALES_LIST.length - 1]
                : activedMonthlySales
            }
          />
        </div>
      )}
    </div>
  );
};

export default BarChartSection;
export const MOCK_CHART_MONTHLY_SALES_LIST = membershipStatisticsMock.monthlySalesList.slice(1);
// 총 매출액 목데이터
export const MOCK_SALES_AMOUNT =
  membershipStatisticsMock.monthlySalesList[membershipStatisticsMock.monthlySalesList.length - 1]
    ?.SalesAmount ?? 0;

// 전월 동기간 대비 증감 목데이터
export const MOCK_DIFF = membershipStatisticsMock.salesDiffAmount;
